import $ from 'jquery';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import GalleryActionCreators from '../../actions/GalleryActionCreators.js';
import GalleryStore from '../../stores/GalleryStore';
import MemberStore from '../../stores/MemberStore';
import ImageSvg from '../images/ImageSvg.react';
import CloseIcon from '../misc/CloseIcon.react';
import GalleryImage from './GalleryImage.react';
import GalleryBoxPanel from './GalleryBoxPanel.react';

const ReactPropTypes = PropTypes;

const largeImagePath = `${globals.imagesBaseUri}h/`;
const largeImagePathGcloud = `${globals.gcloudUri}h/`;
let lastNavigation = null; // glabā pēdējās darbības vērtību (prev vai next)
let preloadIndexes = []; // glabā bilžu index vērtības, kuriem uzsākta ielāde
let firstImageStatus = null; // pirmās bildes ielādes status, tikai, kad ir ielādēta pirmā bilde, nostrādā preload priekš nākamajām

// state vērtības no store
function getStateFromStores() {
  return {
    index: GalleryStore.getCurrentIndex(), // bildes indekss vērtība
    image: GalleryStore.getCurrent(), // bildes objekts
    total: GalleryStore.getTotal(),
    member: MemberStore.get(_.get(globals, 'memberId', 'none')),
  };
}

class GalleryBoxMain extends React.Component {
	// mixins: [PureRenderMixin],

	static propTypes = {
	  onClose: ReactPropTypes.func,
	};

	static defaultProps = {
	  onClose: null,
	};

	constructor(props, context) {
	  super(props, context);
	  // atjauno default vērtības, lai atverot pa jaunu nesaglabā vērtības
	  lastNavigation = null; // glabā pēdējās darbības vērtību (prev vai next)
	  preloadIndexes = []; // glabā bilžu index vērtības, kuriem uzsākta ielāde
	  firstImageStatus = null; // pirmās bildes ielādes status, tikai, kad ir ielādēta pirmā bilde, nostrādā preload priekš nākamajām

	  // set state data
	  const stateData = getStateFromStores();

	  if (stateData.image) {
	    this.preloadImage(stateData.index, stateData.image.get('file'), stateData.image.get('gcloud'));
	  }

	  this.state = stateData;
	}

	componentDidMount() {
	  GalleryStore.addChangeListener(this._onChange);
	  $(document.body).on('keydown.galleryboxmain', this._onKeyDown);
	}

	componentWillUnmount() {
	  GalleryStore.removeChangeListener(this._onChange);
	  $(document.body).off('keydown.galleryboxmain', this._onKeyDown);
	}

	shouldComponentUpdate(nextProps, nextState) {
	  // render tikai tad, kad ir notikušas izmaiņas - jauna bilde, bildei nomainās load_status, ...
	  if (nextState.image !== this.state.image) {
	    return true;
	  }

	  return false;
	}

	// preload norādītajai bildei
	preloadImage = (index, filename, gcloud = false) => {
	  // ja bildei jau uzsākta ielāde, tad tālāk neizpilda
	  if (_.find(preloadIndexes, value => index == value)) {
	    return false;
	  }

	  const self = this;
	  // pirmā bilde vēl nav
	  if (!firstImageStatus) {
	    firstImageStatus = 'open'; // uzsāk ielādi
	  }

	  var imgSrc = largeImagePath + filename;

	  if(gcloud) {
	  	imgSrc = largeImagePathGcloud + filename + '.jpg';
	  }

	  $('<img/>')
	    .on('load', () => {
	      // pirmās bildes ielādes process pabeigts
	      if (firstImageStatus != 'load') {
	        firstImageStatus = 'load';
	        // veic nākošās bildes ielādi
	        self.preloadNextImage();
	      }
	      // pazīme, ka bilde ielāde
	      GalleryActionCreators.loadImage(index, 'ok');
	    })
      // Jaunajā versijā, atverot galeriju, izpilda šo 'error' funkciju, lai gan bilde ielādējas..
      // Kas noved pie tā, ka nerāda pogas 'Man Patīk' un 'Ziņot par bildi'..
      // Pagaidu risinājums - atzīmēt statusu 'ok', jebkurā gadījumā..
	    .on('error', () => {
	      // pirmās bildes ielādes process pabeigts
	      if (firstImageStatus != 'load') {
	        firstImageStatus = 'load';
	        // veic nākošās bildes ielādi
	        self.preloadNextImage();
	      }
	      // pazīme - kļūda ielādē
	      // GalleryActionCreators.loadImage(index, 'error');
        GalleryActionCreators.loadImage(index, 'ok');
	    })
	    .attr('src', imgSrc);
	  preloadIndexes.push(index);
	};

	// preload nākošai bildei
	preloadNextImage = () => {
	  // galerija tukša vai tikai viena bilde
	  if (!this.state.total || this.state.total == 1) {
	    return false;
	  }

	  // iegūst nākošās bildes objektu
	  const nextImage = GalleryStore.getNextImage();
	  if (nextImage) {
	    this.preloadImage(nextImage.index, nextImage.file, nextImage.gcloud);
	  }
	};

	// preload iepriekšējai bildei
	preloadPrevImage = () => {
	  // galerija tukša vai tikai viena bilde
	  if (!this.state.total || this.state.total == 1) {
	    return false;
	  }

	  // iegūst iepriekšējās bildes objektu
	  const prevImage = GalleryStore.getPrevImage();
	  if (prevImage) {
	    this.preloadImage(prevImage.index, prevImage.file, prevImage.gcloud);
	  }
	};

	// pārslēgties uz nākošo bildi
	goToNextImage = () => {
	  lastNavigation = 'next';
	  GalleryActionCreators.nextImage();
	  this.preloadNextImage();
	};

	// pārslēgties uz iepriekšējo bildi
	goToPrevImage = () => {
	  lastNavigation = 'prev';
	  GalleryActionCreators.prevImage();
	  this.preloadPrevImage();
	};

	showUncensored = (filename) => {
	  GalleryStore.setUncensoredByFilename(filename, false);
	  GalleryStore.setLocalUncensoredByFilename(filename, false);
	  GalleryStore.emitChange();
	}

	render() {
	  // nav pievienoti bilžu dati
	  if (!this.state.image) {
	    return null;
	  }

	  const self = this;

	  const Buttons = function () {
	    // ja tukša galerija vai 1 bilde, nerāda pogas
	    if (self.state.total < 2) {
	      return null;
	    }

	    return (
	      <div className="galleryBoxMain-buttons">
	        <a href="#" onClick={self._onClickPrev} className="galleryBoxMain-buttons-item">
	          <ImageSvg svg="icon-arrowleftlarge" />
	        </a>
	        <a href="#" onClick={self._onClickNext} className="galleryBoxMain-buttons-item galleryBoxMain-buttons-item--right">
	          <ImageSvg svg="icon-arrowrightlarge" />
	        </a>
	      </div>
	    );
	  };

	  // nepieciešams norādīt dzimumu katrai bildei
	  let sex = null;
	  if (!_.isEmpty(this.state.member) && !_.isEmpty(this.state.member.sex)) {
	    sex = this.state.member.sex.toLowerCase();
	  }

	  const filename = this.state.image.get('file');

	  const uncensored = this.state.image.get('uncensored');
	  const UncensoredWarning = () => {
	    if (!uncensored) {
	      return (null);
	    }

	    return (
	      <div className="galleryBoxMain-uncensored vcenter poa abst">
	        <div className="vcenter-inner">
	          <div className="tcl mam mtxs">
	            {_.get(translations, 'txt: Šis attēls, iespējams, ir seksuāla vai vardarbīga rakstura.', '')}
	          </div>
	          <div
	            role="button"
	            onClick={() => this.showUncensored(filename)}
	            onKeyDown={() => this.showUncensored(filename)}
	            tabIndex="0"
	            className="btn btn--b btn--small mtxs mrs mbxs mls tac"
	          >
	            {_.get(translations, 'txt: Parādīt attēlu', '')}
	          </div>
	        </div>
	      </div>
	    )
	  }

	  return (
	    <div className="galleryBoxMain" onClick={self._onClickStop}>
	      <GalleryImage
	        filename={filename}
	        loadStatus={this.state.image.get('load_status')}
	        sex={sex}
	        gcloud={this.state.image.get('gcloud')}
	        uncensored={uncensored}
	      />
	      {Buttons()}
	      {UncensoredWarning()}
	      <GalleryBoxPanel
	        showReportButton={this.props.showReportButton}
	        showLikeButton={this.props.showLikeButton}
	        showComplimentButton={this.props.showComplimentButton}
	      />
	      <div className="galleryBoxMain-close">
	        <CloseIcon large onClick={this.props.onClose} />
	      </div>
	    </div>
	  );
	}

	/**
	* Event handler for 'change' events coming from the stores
	*/
	_onChange = () => {
	  const stateData = getStateFromStores();

	  // veic bildes ielādi un uzsetot loadStatus vērtību
	  if (stateData.image && !stateData.image.get('load_status')) {
	    this.preloadImage(stateData.index, stateData.image.get('file'), stateData.image.get('gcloud'));
	  }

	  this.setState(stateData);
	};

	/**
	* Event handler for 'onClick' - Next image
	*/
	_onClickNext = (e) => {
	  e.preventDefault();
	  this.goToNextImage();
	};

	/**
	* Event handler for 'onClick' - Prev image
	*/
	_onClickPrev = (e) => {
	  e.preventDefault();
	  this.goToPrevImage();
	};

	/**
	* Event handler for 'onKeyDown'
	*/
	_onKeyDown = (event) => {
	  // jābūt vairāk kā vienai bildei
	  if (this.state.total > 1) {
	    // dodas pa kreisi
	    if (event.keyCode == 37) {
	      this.goToPrevImage();
	    }
	    // dodas pa labi
	    else if (event.keyCode == 39) {
	      this.goToNextImage();
	    }
	  }
	};

	_onClickStop = (e) => {
	  e.stopPropagation();
	};
}

module.exports = GalleryBoxMain;
